// Hook responsive partagé — fondation du chantier "responsive global".
// Permet de basculer les styles inline selon la largeur d'écran (le code
// utilise des styles inline, donc pas de media queries CSS classiques).
//
// Points de rupture :
//   - 768  : mobile (téléphone) → listes en cartes empilées, contenu compacté
//   - 1024 : barre de navigation repliée en menu burger (9 onglets débordent avant)
import { useState, useEffect } from 'react';

export const BREAKPOINT_MOBILE = 768;
export const BREAKPOINT_NAV = 1024;

export function useIsMobile(breakpoint = BREAKPOINT_MOBILE) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpoint]);

  return isMobile;
}
